import { productSelectorVariantModalStyles } from "@insite/content-library/Components/ProductSelectorVariantModal";
import { css } from "styled-components";

productSelectorVariantModalStyles.modal = {
    size: 400,
    cssOverrides: {
        modalContainer: css`
            align-items: center;
        `,
        modalTitle: css`
            padding: 10px 20px;
        `,
        modalContent: css`
            padding: 20px;
        `,
    },
};
